// TODO: jsdoc
export default function interpolate(str, params) {
    for (var _i = 0, _a = Object.entries(params); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        var regex = RegExp("{" + key + "}", "g");
        var matches = void 0;
        while ((matches = regex.exec(str)) !== null)
            str = str.replace(matches[0], value);
    }
    return str;
}
